"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _DOMSelectors = require("../constants/DOMSelectors");

var _ResendVerificationEmailButton = _interopRequireDefault(require("./ResendVerificationEmailButton"));

var EmailConfirmBarTemplate = function EmailConfirmBarTemplate(email) {
  return "\n    <div\n      class=\"fire-alarm_alarm fire-alarm_maintenance fire-alarm_borderless\"\n      role=\"alert\"\n      aria-live=\"assertive\"\n      aria-atomic=\"true\">\n        <div class=\"fire-alarm_alarm-inner\">\n          <div class=\"fire-alarm_alarm-body p-all-2\">\n            <p class=\"display-inline\">" + _I18n.default.text('emailConfirmBar.title', {
    email: email
  }) + "</p>\n            <div class=\"display-inline\" id=\"" + _DOMSelectors.EMAIL_CONFIRM_ACTIONS_ID + "\">\n              " + (0, _ResendVerificationEmailButton.default)() + "\n            </div>\n          </div>\n        </div>\n    </div>\n  ";
};

var _default = EmailConfirmBarTemplate;
exports.default = _default;
module.exports = exports.default;